import {
    USERS_LOADED,
    MANAGERS_LOADED
} from "../constants/actionTypes";

export default (state = {}, action) => {
    switch (action.type) {
    case USERS_LOADED:
        return {
            ...state,
            ...action.payload,
        };
    case MANAGERS_LOADED:
        return {
            ...state,
            ...action.payload,
        };
    default:
        return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/users.js